<template>
  <div
    :style="{
      top: coordinates.top,
      left: coordinates.left,
    }"
    :class="[$style.grid_editor_popup, dropToBottom ? '' : $style.popup_top]"
  >
    <div
      v-for="option in options"
      :key="option.id"
    >
      <div
        :data-testid="`gp_autotest_gantt_grid_priority_item_${option.id}`"
        :class="[$style.popup_item, value === option.id ? $style.popup_item_selected : '']"
        @click="selectValue(option)"
      >
        <img
          :src="option.icon"
          :class="$style.popup_item_image"
        >
        <span>
          {{ option.locale ? locales(option.locale) : option.value }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GridPriorityCellEditor',
  props: {
    placeholder: {
      type: Object,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    onSave: {
      type: Function,
      required: true,
    },
    onCancel: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      locales: __,
      value: '',
      coordinates: {
        left: 'auto',
        top: 'auto',
      },
      dropToBottom: true,
    };
  },
  created() {
    this.calcCoordinates();
  },
  mounted() {
    this.placeholder.addEventListener('wheel', this.onScrollPlaceholder, { passive: true });
    document.addEventListener('keydown', this.onKeyDown);
  },
  beforeUnmount() {
    this.placeholder.removeEventListener('wheel', this.onScrollPlaceholder);
    document.removeEventListener('keydown', this.onKeyDown);
  },
  methods: {
    selectValue(item) {
      this.value = item.id;
      this.onSave();
    },

    calcCoordinates() {
      const coordinates = this.placeholder.getBoundingClientRect();
      const clientHeight = document.documentElement.clientHeight;
      const elementHeight = 180;

      this.dropToBottom = (coordinates.bottom + elementHeight) < clientHeight;

      if (this.dropToBottom) {
        this.coordinates = {
          top: `${coordinates.bottom + 1}px`,
          left: `${coordinates.left}px`,
        };
      } else {
        this.coordinates = {
          top: `${coordinates.top - elementHeight - 2}px`,
          left: `${coordinates.left}px`,
        };
      }
    },

    onScrollPlaceholder(event) {
      // stop event bubbling to allow scrolling inside editor
      event.stopPropagation();
    },

    onKeyDown(event) {
      if (event.keyCode === 38) { // up
        const itemIndex = this.options.findIndex(item => item.id === this.value);

        if (itemIndex > -1 && this.options[itemIndex - 1]) {
          this.value = this.options[itemIndex - 1].id;
        }
      }

      if (event.keyCode === 40) { // down
        const itemIndex = this.options.findIndex(item => item.id === this.value);

        if (itemIndex > -1 && this.options[itemIndex + 1]) {
          this.value = this.options[itemIndex + 1].id;
        }
      }

      if (event.keyCode === 13) { // enter
        this.onSave();
      }

      if (event.keyCode === 27) { // esc
        this.onCancel();
      }
    },
  },
};
</script>

<style module src="../styles/gridEditor.less" lang="less"></style>
